import { LeadPerson } from "features/Resources/Meeting/models";
import { BulkScheduleAttendee, BulkScheduleConfirmResult } from "./models";

/** The session lead as a normalized LeadPerson, derived from the flagged attendee. */
export function leadFromAttendees(attendees: BulkScheduleAttendee[]): LeadPerson | undefined {
  const lead = attendees.find((attendee) => attendee.isLead);
  return lead?.id != null ? { id: String(lead.id), name: lead.name ?? "", avatarUrl: lead.avatarUrl } : undefined;
}

export interface ConfirmResultsSummary {
  total: number;
  scheduledCount: number;
  releasedCount: number;
  failedCount: number;
  allScheduled: boolean;
}

export function summarizeConfirmResults(results: BulkScheduleConfirmResult[]): ConfirmResultsSummary {
  const total = results.length;
  const scheduledCount = results.filter((r) => r.status === "scheduled").length;
  const releasedCount = results.filter((r) => r.status === "released").length;
  const failedCount = total - scheduledCount - releasedCount;
  // total 0 means the job found none of the requested holds — not a success
  const allScheduled = total > 0 && scheduledCount === total;

  return { total, scheduledCount, releasedCount, failedCount, allScheduled };
}
